export const VENUE_UUID = "0007a854-29c1-4a71-a309-79330f79e02e"